export const debounce = (func, delay) => {
    let timeoutId;

    return (...args) => {
        if (timeoutId) clearTimeout(timeoutId);

        timeoutId = setTimeout(() => {
            func.apply(this, args)
        }, delay);
    }
}